import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";

export default class Spike extends Fragment {
    constructor(spikedBy) {
        super();
        this.spikedBy = spikedBy;

        this.requiredData = [
            {
                name: "spikedBy",
                type: FragmentDataType.Player,
                displayName: "Spiked by",
                title: (team) => `Spiked By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    getFragmentTeamId() {
        return this.spikedBy?.teamId;
    }

    summarize(summaryContext, stringifier) {
        return new FragmentSummary(
            `${stringifier.firstInitial(this.spikedBy)} spike`
        );
    }

    updateSummaryContext(summaryContext) {
        summaryContext.playerInPossession = this.spikedBy;
    }

    getPlayers() {
        return [this.spikedBy];
    }

    toJSON() {
        return {
            ...super.toJSON(),
            spikedBy: playerReducer(this.spikedBy)
        };
    }
}
